'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useCarouselPrevNextButtons: ()=>useCarouselPrevNextButtons
});
const external_react_namespaceObject = require("react");
const useCarouselPrevNextButtons = (emblaApi, loop = true)=>{
    const [prevBtnDisabled, setPrevBtnDisabled] = (0, external_react_namespaceObject.useState)(true);
    const [nextBtnDisabled, setNextBtnDisabled] = (0, external_react_namespaceObject.useState)(true);
    const [prevBtnHidden, setPrevBtnHidden] = (0, external_react_namespaceObject.useState)(false);
    const [hasUserInteracted, setHasUserInteracted] = (0, external_react_namespaceObject.useState)(false);
    const onPrevButtonClick = (0, external_react_namespaceObject.useCallback)(()=>{
        if (!emblaApi) return;
        setHasUserInteracted(true);
        emblaApi.scrollPrev();
    }, [
        emblaApi
    ]);
    const onNextButtonClick = (0, external_react_namespaceObject.useCallback)(()=>{
        if (!emblaApi) return;
        setHasUserInteracted(true);
        emblaApi.scrollNext();
    }, [
        emblaApi
    ]);
    const onSelect = (0, external_react_namespaceObject.useCallback)((emblaApi)=>{
        const canScrollPrev = emblaApi.canScrollPrev();
        const canScrollNext = emblaApi.canScrollNext();
        setPrevBtnDisabled(!canScrollPrev);
        setNextBtnDisabled(!canScrollNext);
        if (loop || hasUserInteracted) setPrevBtnHidden(false);
        else {
            const isAtStart = 0 === emblaApi.selectedScrollSnap();
            setPrevBtnHidden(isAtStart);
        }
    }, [
        loop,
        hasUserInteracted
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (!emblaApi) return;
        onSelect(emblaApi);
        emblaApi.on('reInit', onSelect).on('select', onSelect);
        const onPointerDown = ()=>setHasUserInteracted(true);
        emblaApi.on('pointerDown', onPointerDown);
        return ()=>{
            emblaApi.off('reInit', onSelect).off('select', onSelect).off('pointerDown', onPointerDown);
        };
    }, [
        emblaApi,
        onSelect
    ]);
    return {
        prevBtnDisabled,
        nextBtnDisabled,
        prevBtnHidden,
        onPrevButtonClick,
        onNextButtonClick
    };
};
exports.useCarouselPrevNextButtons = __webpack_exports__.useCarouselPrevNextButtons;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "useCarouselPrevNextButtons"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
